<template>
	  <div>
		    <div class="tickets-list">
            <div class="tickets-list-route ">
                <ul >
                    <li @click="routetokPage('/tickets')">门票预订 ></li>
                    <li class="active">门票</li>
                </ul>
            </div>
            <AutoComplete @search="search" :param="Str"></AutoComplete>
       		  <div class="main-left-list">
               	<div class="cnhotel-list-top-list">
               		  <div class="pull-left">
               			    <div class="cnhotel-list-sort active">推荐</div>
               			 <!--    <div class="cnhotel-list-sort">价格</div>
               			    <div class="cnhotel-list-sort">价格</div> -->
               		  </div>
               		  <div class="pull-right">
               			    <div class="ticket-list-total">
               				      为您搜到<span class="color-orange"> {{Total}} </span>种门票
               			    </div>
               		  </div>
               	</div>
                <div class="table-loading" v-if="isLoading">
                    <Loading :isLoading="isLoading"></Loading>
                </div>
               	<div class="tickets-box" v-else>
               		  <div class="list-item" v-for="item in list">
               			    <img :src="item.Pic|replaceImgSrc(4)"  alt="" class="ticket-list-img" @click="pushList(item)"/>
               			    <div class="item-content">
               				      <h4 @click="pushList(item)">
                                {{item.ScenicName}}
                                <span> [{{item.ProvinceName?item.ProvinceName+' • ':''}}{{item.CityName||''}} ]</span>
                            </h4>
               				      <p>景点地址<span> {{item.ScenicAddr}}</span></p>
               				      <p>景点主题
                                <span v-for="t in item.ScenicThemes"> {{t.Name}}</span>
                            </p>
               				      <p v-if="item.ScenicLevelName">景区级别<span> {{item.ScenicLevelName}}级景区</span></p>
               				      <div class="price-list" v-if="item.LowestPrice">
               					        <p>￥ <span>{{item.LowestPrice}}</span> 起</p>
               					        <div class="btn" @click="pushList(item)">产品详情</div>
               				      </div>
               			    </div>
               	      </div>
               	</div>
                <Paginate :pageIndex="Page" :pageTotal="Math.ceil(Total/PageSize)" @select="pageSelect" v-if="Total>10">
                </Paginate>
       		  </div>
		    </div>
	 </div>
</template>
<script>
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import Paginate from './../../common/cmpnt/paginate/paginate.vue'//分页
    import AutoComplete from './autoComplete/autoComplete.vue'//自动完成
	  export default {
        components: {
            Loading,
            Paginate,
            AutoComplete
        },
		    data () {
			      return {
				        Str:this.$route.query.Str||'',
                list:'',
                Page:1,
                PageSize:10,
                Total:0,
                MyLat:'',
                isLoading:false
			      }
		    },
		    methods: {
			      pushList (item) {
                window.open( '#/ticketDetails?id='+item.ScenicId+'&Str='+this.Str, '_blank');
				    	
			      },
            search(str){
                this.Str=str;
                this.initData();
            },
            pageSelect(val){
                this.Total = 0;
                this.list = '';
                this.Page = val;
                this.initData();
            },
            initData(str) {

                var that = this;
                
                that.isLoading=true;
                var params = {
                    Str: that.Str,
                    TicketType: '',
                    Level: '',
                    Page: that.Page,
                    PageSize: that.PageSize,
                    MyCity: '',
                    Radius: '',
                    MyLat: '',
                    MyLon: '',
                }
                that.postRequest({
                    url:that.Api.getTicketList,
                    params: params
                }).then(res => {
                    that.isLoading=false;
                    if (res && res.IsSuccess) {
                        that.list=res.Result;
                        that.Total=res.Total;
                    } else {
                        // $state.complete();
                    }
                });
            }
		    },
        mounted(){
            this.initData();
        }
	  }
</script>


// WEBPACK FOOTER //
// src/components/ticket/list.vue